import { OmnivaParcelMachine } from '../types/shipping';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

export async function fetchOmnivaLocations(): Promise<OmnivaParcelMachine[]> {
  try {
    console.log('Fetching Omniva parcel machines...');
    
    const response = await fetch(`${SUPABASE_URL}/functions/v1/omniva-lockers`, {
      headers: {
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Failed to fetch Omniva parcel machines:', response.status, errorText);
      throw new Error('Failed to fetch Omniva parcel machines from Supabase Edge Function');
    }
    
    const data = await response.json();
    console.log(`Successfully fetched ${data.length} Omniva parcel machines`);
    
    return data;
  } catch (error) {
    console.error('Error fetching Omniva parcel machines:', error);
    return [];
  }
}